import { DEFINITIONS_BASE_PATH } from './definitions-base-path.js';

const base = `${DEFINITIONS_BASE_PATH}/compliance`;

export const complianceTabsConfig = {
  basePath: base,
  tabs: [
    {
      id: 'regulatory-sources',
      path: `${base}/regulatory-sources`,
      pageKey: 'definitionsComplianceRegulatorySources',
    },
    {
      id: 'clauses',
      path: `${base}/clauses`,
      pageKey: 'definitionsComplianceClauses',
    },
    {
      id: 'obligations',
      path: `${base}/obligations`,
      pageKey: 'definitionsComplianceObligations',
    },
    {
      id: 'frameworks',
      path: `${base}/frameworks`,
      pageKey: 'definitionsComplianceFrameworks',
    },
    {
      id: 'report-definitions',
      path: `${base}/report-definitions`,
      pageKey: 'definitionsGovernanceReports',
    },
  ],
};
